<template>
	<ChoosePlacementForButtonDropdown :placements="placements" :service="service" v-bind="{ ...$props, ...$attrs }" v-on="$listeners" />
</template>

<script>
import { getPlacementsOfService } from '@/store/modules/placements/actions';
import ChoosePlacementForButtonDropdown from './ChoosePlacementForButtonDropdown.vue';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { getServicePlacements } from '@/store/modules/placements/getters';
import { getService } from '@/store/modules/apps/getters';
import props from './ChoosePlacementForButtonDropdownDataProvider.props';
import { getPlacementVersion } from '@/store/modules/placements/modules/versions/getters';
export default {
	name: 'ChoosePlacementForButtonDropdownDataProvider',
	props,
	components: { ChoosePlacementForButtonDropdown },
	computed: {
		...mapGettersShorthand({ getServicePlacements, getService, getPlacementVersion }),
		placements() {
			// we do not filter the non-active placements on purpose, user might have add-ons on non-active placements
			return this.getServicePlacements(this.selectedAppId).map((placement) => ({
				...placement,
				version: this.getPlacementVersion(placement.id, this.service.version),
			}));
		},
		service() {
			return this.getService(this.selectedAppId);
		},
	},
	methods: {
		...mapActionsShorthand({ getPlacementsOfService }),
	},
	mounted() {
		this.getPlacementsOfService({ serviceId: this.selectedAppId });
	},
};
</script>

<style lang="scss"></style>
